<template>
  <main v-if="status">
    <loading :status="status" />
  </main>
  <main v-else>
    <h2 class="main">Create your own project</h2>
    <section class="new-project">
      <p class="container">
        <label for="name">Name:</label>
        <input type="text" v-model="pName" id="name" name="name" required />
      </p>
      <p class="container">
        <label for="description">Description:</label>
        <textarea v-model="pDescription" id="description" name="description" required ></textarea>
      </p>
      <dl class="container">
        <dt>Skills</dt>
        <div class="skills">
          <dd v-for="skill in skills" :key="skill.id">
            <span
              class="skill"
              :style="{ backgroundColor: skill.color, color: getTextColor(skill.color) }"
            >
              <input type="checkbox" :value="skill.id" v-model="pSkills" :id="skill.id" />
              <label :for="skill.id">{{ skill.name }} ({{ skill.weight }})</label>
            </span>
            <RouterLink :to="{ name: 'skill-detail', params: { id: skill.id } }" target="_blank"
              >🔎</RouterLink
            >
            <span>{{ skill.description }}</span>
          </dd>
        </div>
      </dl>
      <p class="container">
        <label>&nbsp;</label>
        <button @click="createProject" :disabled="!formChack">Create project</button>
      </p>
    </section>
  </main>
</template>

<style scoped lang="scss">

@use 'sass:color';

button:disabled {
  background-color: #cccccc !important;
  color: #666666 !important;
  cursor: not-allowed;
  box-shadow: none !important;
  transform: none !important;
}

.new-project {
  margin: 1rem auto;
  background-color: rgba($primari, 0.15);
  padding: 2rem;
  border-radius: 8px;

  .container {
    display: flex;
    margin: 22px;

    label,
    dt {
      flex: 2;
    }

    input,
    textarea,
    div.skills,
    button {
      flex: 10;
    }

    textarea {
      height: 12em;
    }
  }

  button {
    display: inline-block;
    font-size: 1.5rem;
    background-color: $btnColor;
    color: white;
    padding: 1rem;
    border-radius: 122px;
    border: none;
    cursor: pointer;
  }

  .skill {
    display: inline-block;
    margin: 0.5rem;
    padding: 0.5rem;
    border-radius: 7px;

    input {
      display: inline-block;
    }
  }
}

</style>

<script setup>

import { ref, computed, onMounted } from 'vue'
import {useRouter} from 'vue-router'
import { api } from '../utils/axios'
import loading from '@/components/loading.vue'
import confirmDialog from '@/utils/confirmDialog'
import { useMessagesStore } from '@/stores/messages'
import { getTextColor } from '../utils/helpers'

const router = useRouter()
const messages = useMessagesStore()

const skills = ref([])
const status = ref('loading')
const pName = ref('')
const pDescription = ref('This can be changed later.')
const pSkills = ref([])

const formChack = computed(() => {
  return pName.value && pDescription.value && pSkills.value.length
})

onMounted(async () => {
  try {
    const response = await api.get('/skills')
    skills.value = response.data
    status.value = null
  } catch (error) {
    status.value = error.response?.data?.msg || 'Error fetching projects data'
    messages.error('❌ Error: ' + (error.response?.data?.msg || error.message))
  }
})

async function createProject() {
  const confirmed = await confirmDialog.confirm({
    title: 'Create new project',
    message: 'Really create a new project?',
    confirmText: 'Yes',
    cancelText: 'No',
  })
  if (!confirmed) return

  try {
    const response = await api.post('/project/new', {
      name: pName.value,
      description: pDescription.value,
      skills: pSkills.value,
    })
    let projectId = response.data.project_id
    messages.success('👍' + response.data.msg)
    router.push({ name: 'project-detail', params: { id: projectId } } )
  } catch (error) {
    messages.error('❌ Error: ' + (error.response?.data?.msg || error.message))
  }
}

</script>
